import { connect } from 'react-redux';
import HomePage from './homePage';

const mapStateToProps = state => ({
  clientSize: state.clientSize,
  sidePanelOpen: state.sidebar.isOpen,
  sidePanelWidth: state.sidebar.updatedPosition,
});

export default connect(mapStateToProps)(HomePage);
